import React, { useEffect, useRef, useState } from "react";
import { Table, Tooltip, Col, Input, Row, Image, Switch, Tag, Upload, Button, Card } from "antd";
import HeadingBack from "./common/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SvgIcon from "./const/SvgIcon";
import { allApiAction } from "../Redux/common/action";

import { DeleteOutlined, ExclamationCircleFilled, PlusOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { toast } from "react-toastify";
import { URL } from "../Redux/common/url";
import { AsyncPaginate } from "react-select-async-paginate";
import moment from "moment";
import LoadOptions from "./common/LoadOptions";
import api from "../Redux/common/api";


import { CKEditor } from "ckeditor4-react";

const defaultObj = {
  function_id: "",
  essential_id: "",
  name: "",
  amount: "",
  description: "",
  feature_image: "",
  images: "",
  multiply: false, 
};

function EssentialTypes() {

  const { confirm } = Modal;
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const [showDelelt, setShowDelete] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const [essentialTypesDetails, setEssentialDetails] = useState({ ...defaultObj });
  console.log("essentialTypesDetails ==>", essentialTypesDetails);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [filterData, setFilterData] = useState({ occasion: "", func: "", essential: "" });

  const token = localStorage.getItem("admin_token");

  const { essentialTypesList } = useSelector((state) => ({
    essentialTypesList: state?.allApi?.essential_type_list || {},
  }));

  const listData = essentialTypesList?.data ? essentialTypesList?.data : [];

  useEffect(() => {
    fetchData();
  }, [search, page, filterData]);

  const fetchData = () => {
    const { occasion, func, essential } = filterData;
    dispatch(allApiAction.getEssentialTypes({
      page: page,
      search: search,
      occasion_id: occasion ? occasion?.value : "",
      function_id: func ? func?.value : "",
      essential_id: essential ? essential?.value : ""
    }));

  };

  const columns = [
    {
      width: "10%",
      key: "feature_image",
      title: "Image",
      dataIndex: "feature_image",
      render: (value, item, index) => {
        return (
          <>
            <div style={{ width: "50px" }}>
              <Image src={URL?.API_BASE_URL + item?.feature_image}
                alt="N/A" />
            </div>
          </>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Function",
      dataIndex: "function",
      key: "function",
      render: (value) => value.name
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text, record) => {
        return (
          <>
            <div
              dangerouslySetInnerHTML={{ __html: text }}
              style={{ wordBreak: "break-word", maxWidth: "300px", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical" }}
            />
            <Button 
              type="link" 
              size="small" 
              onClick={() => handleViewDescription(record)}
              style={{ paddingLeft: 0, marginTop: 4 }}
            >
              View
            </Button>
          </>
        );
      },
    },
    {
      title: "Essential",
      dataIndex: "essential",
      key: "essential",
      render: (value) => value.name
    },
    {
      title: "Occasion",
      dataIndex: "occasion",
      key: "occasion",
      render: (value) => value.title
    },
    {
      title: "Multiple",
      dataIndex: "multiply",
      key: "multiply",
      render: (value) => value ? <Tag color="green">Yes</Tag> : <Tag color="red">No</Tag>
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (value) => moment(value).format("DD-MM-YYYY")
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* function_id: "",
              essential_id: "",
              name: "",
              amount: "",
              description: "",
              feature_image: "",
              images: "", */}
            <Tooltip title="Edit">
              <span
                className="cursor-pointer"
                onClick={() => {
                  // const { occasion, function: func, essential } = item;
                  handleModal({
                    ...item,
                    multiply: item.multiply || false // Ensure multiply is always boolean
                    // name: item?.name,
                    // amount: item?.amount,
                    // description: item?.description,
                    // // feature_image
                    // images: item?.name,
                    // occasion_id: { value: occasion?.id, label: occasion?.title },
                    // function_id: { value: func?.id, label: func?.name },
                    // essential_id: { value: essential?.id, label: essential?.name },
                  });
                }}
              >
                <SvgIcon.Edit className="scale-icon edit-icon" />
              </span>
            </Tooltip >
            <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showDeleteConfirm(item?.id);
                }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const handleDelete = async (e) => {
    const { occasion, func, essential } = filterData;

    setShowDelete(false);
    await dispatch(allApiAction.deleteEssentialType({ id: e, page: page }));
    await dispatch(allApiAction.getEssentialTypes({
      page: page,
      search: search,
      occasion_id: occasion ? occasion?.value : "",
      function_id: func ? func?.value : "",
    }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const files = event.target.files;
      setSelectedFile(files);
    }
  };

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    if (name === "occasion_id") {
      setEssentialDetails((prev) => ({ ...prev, [name]: value, function_id: "", essential_id: "" }));
      return;
    } else if (name === "function_id") {
      setEssentialDetails((prev) => ({ ...prev, [name]: value, essential_id: "" }));
      return;
    } else {
      setEssentialDetails((prev) => ({ ...prev, [name]: value }));
    }
  };


  const showDeleteConfirm = (e) => {
    confirm({
      title: "Are you sure delete ?",
      icon: <ExclamationCircleFilled />,
      content: "Essential",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        handleDelete(e);
      },
      onCancel() {
      },
    });
  };

  const handleModal = (editData) => {
    if (editData && editData !== undefined) {
      const { occasion, function: func, essential, images } = editData;

      // Pre-populate fileList with existing images from the API
      const existingImages = images.map((img) => ({
        uid: img.id,
        name: img?.image?.split("/")?.pop(), //
        status: "done",
        url: `${URL.API_BASE_URL}${img.image}`,
        id: img.id,
      }));

      setEssentialDetails({
        id: editData.id,
        name: editData.name,
        amount: editData.amount,
        description: editData.description,
        occasion_id: { value: occasion?.id, label: occasion?.title },
        function_id: { value: func?.id, label: func?.name },
        essential_id: { value: essential?.id, label: essential?.name },
        images: existingImages,
        multiply: editData.multiply || false, // Preserve multiply value
      });
      setFileList(existingImages); // Set the fileList with existing images
    } else {
      setEssentialDetails({ ...defaultObj });
      setFileList([]); // Reset fileList for new entry
    }

    // editData && editData !== undefined ? setEssentialDetails(editData) : setEssentialDetails({ ...defaultObj });
    setIsModalOpen(!isModalOpen);
  };

  const handleSearch = (e) => {
    setSearch(e);
  };

  const handlePageChange = (currentPage) => {
    setPage(currentPage);
  };

  // Handle preview
  const handlePreview = async (file) => {
    setPreviewImage(file.url || file.thumbUrl);
    setPreviewOpen(true);
  };

  // Handle file changes
  // const handleChange = ({ fileList }) => setFileList(fileList);

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const handleResetImages = () => {
    setFileList([]);
    setSelectedFile(null);
    setPreviewImage("");
  };

  const handleDeleteImage = async (imageId) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await api.post(`${URL.delete_image}?id=${imageId}`, { id: imageId }, config);
      if (response.data.status) {
        setFileList((prev) => prev.filter((file) => file.id !== imageId));
        toast.success(response.data.message, { toastId: "imageDeleted" });
      }
    } catch (error) {
      console.error("Error deleting image:", error);
      toast.error("Failed to delete image");
    }
  };

  const checkValidation = () => {
    if (!essentialTypesDetails?.occasion_id) {
      toast.error("Please select occasion First ", { toastId: "typeValidation" });
      return false;
    } else if (!essentialTypesDetails?.function_id) {
      toast.error("Please select Function First ", { toastId: "typeValidation" });
      return false;
    } else if (!essentialTypesDetails?.essential_id) {
      toast.error("Please select Essential ", { toastId: "typeValidation" });
      return false;
    } else if (!essentialTypesDetails?.name) {
      toast.error("Please enter a name", { toastId: "typeValidation" });
      return false;
    } else if (!essentialTypesDetails?.amount) {
      toast.error("Please enter amount", { toastId: "typeValidation" });
      return false;
    } else if (!selectedFile && !essentialTypesDetails?.id) {
      toast.error("Please select feature image", { toastId: "typeValidation" });
      return false;
    } else if (!fileList?.length > 0 && !essentialTypesDetails?.id) {
      toast.error("Please select Images", { toastId: "typeValidation" });
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {

    if (!checkValidation()) {
      return;
    }

    // return;
    const data = new FormData();
    data.append("occasion_id", essentialTypesDetails?.occasion_id?.value);
    data.append("function_id", essentialTypesDetails?.function_id?.value);
    data.append("essential_id", essentialTypesDetails?.essential_id?.value);
    console.log("essentialTypesDetails ==>", essentialTypesDetails);
    //appending required field 
    ["name", "amount"].map((key) => {
      console.log("key ==>", key);
      console.log("essentialTypesDetails?.[key] ==>", essentialTypesDetails?.[key]);

      data.append(key, essentialTypesDetails?.[key]);
    });
    // return;
    //Only append if field is selected
    ["description"].map((key) => {
      if (essentialTypesDetails?.[key]) {
        data.append(key, essentialTypesDetails?.[key]);
      };
    });

    // Added: Append multiply field (true/false)
    data.append("multiply", essentialTypesDetails?.multiply ? "1" : "0");

    if (selectedFile) {
      for (let i = 0; i < selectedFile?.length; i++) {
        data.append("feature_image", selectedFile[i]);
      }
    };

    fileList?.forEach((file, index) => {
      if (!file?.id) {
        data.append(`images[${index}]`, file.originFileObj);
      };
    });
    try {
      if (essentialTypesDetails?.id) {
        data.append("id", essentialTypesDetails?.id);
        await dispatch(allApiAction.updateEssentialType(data));
      } else {
        await dispatch(allApiAction.addEssentialType(data));
      };
      dispatch(allApiAction.getEssentialTypes({ page: 1 }));
      handleResetImages();
      handleModal();
    } catch (error) {
      console.error("Error during API call:", error)
    };
  };

  const handleViewDescription = (item) => {
    const descHTML = item.description || '';
    // Use a temporary Modal (Antd style) since no custom modal was added in the original code
    // This is the most straightforward way to show the full HTML content in a modal
    Modal.info({
      title: "View Description",
      content: (
        <div dangerouslySetInnerHTML={{ __html: descHTML }} />
      ),
      okText: "Close",
      width: 700,
      maskClosable: true,
    });
  };

  return (
    <div>
      {/* Header Bar */}
      <div className="flex" >
        <div>
          <HeadingBack
            title={"Essential Types"}
            subHeading={`Total ${essentialTypesList?.total || 0} Essential Types`}
          />
        </div>

        <div className="flex flex1 align-items-center justify-content-end">
          <Tooltip title="Add">
            <span className="jop_btn" onClick={() => handleModal()}>
              Add
              <SvgIcon.Add width={40} height={40} className="cursor-pointer" />
            </span>
          </Tooltip>
        </div>
      </div>

      {/* Filter section */}
      <div >
        <fieldset>
          <legend>Filters:</legend>
          {/* Filter section */}
          <Row gutter={5} className="">
            <Col md={5} sm={5} xs={12} className="ml-5 pl-5">
              <Input
                type="text"
                autoComplete="new-off"
                className="form-control"
                onChange={(e) => handleSearch(e.target.value)}
                placeholder="Search..."
                value={search}
              />
            </Col>
            <Col md={4} sm={4} lg={4} xs={6} className="ml-5">
              <AsyncPaginate
                // key={managerKeyJen}
                additional={{ page: 1, value: "id", label: "title" }}
                className="p-0"
                placeholder=" Occasion"
                value={filterData?.occasion}
                loadOptions={(search, loaded, additional) => LoadOptions(URL.get_occasions, search, loaded, additional)}
                onChange={(value) => {
                  setFilterData((prev) => ({ ...prev, occasion: value, func: "", esential: "" }));
                }}
              />
            </Col>
            <Col md={4} sm={4} lg={4} xs={6} className="ml-5">
              <AsyncPaginate
                key={filterData?.occasion?.value || "oId1"}
                additional={{
                  page: 1, value: "id", label: "name",
                  extras: {
                    occasion_id: filterData?.occasion ? filterData?.occasion?.value : ""
                  }
                }}
                className="p-0"
                placeholder="Function"
                value={filterData?.func}
                loadOptions={(search, loaded, additional) => LoadOptions(URL.get_functions, search, loaded, additional)}
                onChange={(value) => {
                  setFilterData((prev) => ({ ...prev, func: value, essential: "" }))
                }}
              />
            </Col>
            <Col md={4} sm={4} lg={4} xs={6} className="ml-5">
              <AsyncPaginate
                // key={managerKeyJen}
                additional={{
                  page: 1, value: "id", label: "name", extras: {
                    occasion_id: filterData?.occasion ? filterData?.occasion?.value : "",
                    function_id: filterData?.func ? filterData?.func?.value : ""
                  }
                }}
                className="p-0"
                placeholder="Essential"
                value={filterData?.essential}
                loadOptions={(search, loaded, additional) => LoadOptions(URL.get_essentials, search, loaded, additional)}
                onChange={(value) => {
                  setFilterData((prev) => ({ ...prev, essential: value }))
                }}
              />
            </Col>

            {/* Filter control buttons */}
            <Col md={4} sm={4} xs={12} className="ml-5">
              <Button
                className="ml-2"
                onClick={() => {
                  setFilterData({ occasion: "", func: "", essential: "" });
                  setSearch("");
                }}
                disabled={!filterData?.func && !filterData?.occasion && !filterData?.essential}
              >
                Reset
              </Button>
            </Col>
          </Row>
        </fieldset>
      </div>

      {/* Pagination Table */}
      <div className="tableResponsive mt-10">
        <Table
          dataSource={listData}
          columns={columns}
          className={"table antd_table"}
          pagination={{
            current: page,
            pageSize: 10,
            onChange(currentPage, pageSize) {
              handlePageChange(currentPage);
            },
            hideOnSinglePage: true,
            total: essentialTypesList?.total ? essentialTypesList?.total : 0,
          }}
        />
      </div>

      {/* Form Modal */}
      <Modal
        key={isModalOpen ? "Modal Open" : "Modal Close"}
        title="Essential Type Modal"
        open={isModalOpen}
        onOk={handleSubmit}
        onCancel={() => setIsModalOpen(false)}
      >
        <Row gutter={[20, 20]}>
          <Col lg={12} md={12} sm={12} xs={12}>
            <label className="mb-2">Select Occasion : </label>
            <AsyncPaginate
              additional={{ page: 1, value: "id", label: "title" }}
              className="p-0"
              value={essentialTypesDetails?.occasion_id}
              loadOptions={(search, loaded, additional) => LoadOptions(URL.get_occasions, search, loaded, additional)}
              onChange={(value) => {
                handleTextChange({ target: { name: "occasion_id", value: value } });
              }}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}>
            <label className="mb-2">Select Function : </label>
            <AsyncPaginate
              key={essentialTypesDetails?.occasion_id?.value || "oId1"} // Unique key for re-rendering
              additional={{
                page: 1,
                value: "id",
                label: "name",
                extras: {
                  occasion_id: essentialTypesDetails?.occasion_id?.value || "", // Send occasion_id
                },
              }}
              className="p-0"
              value={essentialTypesDetails?.function_id}
              loadOptions={(search, loaded, additional) => LoadOptions(URL.get_functions, search, loaded, additional)}
              onChange={(value) => {
                handleTextChange({ target: { name: "function_id", value: value } });
              }}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}>
            <label className="mb-2">Select Essential : </label>
            <AsyncPaginate
              key={`${essentialTypesDetails?.occasion_id?.value || "oId1"}-${essentialTypesDetails?.function_id?.value || "fId1"
                }`} // Unique key for re-rendering
              additional={{
                page: 1,
                value: "id",
                label: "name",
                extras: {
                  // occasion_id: essentialTypesDetails?.occasion_id?.value || "",
                  function_id: essentialTypesDetails?.function_id?.value || "", // Send function_id
                },
              }}
              className="p-0"
              value={essentialTypesDetails?.essential_id}
              loadOptions={(search, loaded, additional) => LoadOptions(URL.get_essentials, search, loaded, additional)}
              onChange={(value) => {
                handleTextChange({ target: { name: "essential_id", value: value } });
              }}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}>
            <label className="mb-2">Name : </label>
            <input
              autoComplete="off"
              className="form-control"
              placeholder="Enter Name"
              name="name"
              value={essentialTypesDetails?.name}
              onChange={handleTextChange}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}>
            <label className="mb-2">Amount : </label>
            <input
              autoComplete="off"
              className="form-control"
              placeholder="Enter Amount"
              name="amount"
              value={essentialTypesDetails?.amount}
              onChange={(e) => {
                const value = e.target.value;
                if (/^-?\d*\.?\d*$/.test(value)) {
                  handleTextChange({ target: { name: "amount", value } });
                }
              }}
            />
          </Col>

          {/* Added: Multiply Switch Field */}
          <Col lg={12} md={12} sm={12} xs={12}>
            <label className="mb-2">Multiply by Guests : </label>
            <div>
              <Switch
                checked={essentialTypesDetails?.multiply}
                onChange={(checked) => {
                  setEssentialDetails((prev) => ({ ...prev, multiply: checked }));
                }}
              />
              <span className="ml-3">{essentialTypesDetails?.multiply ? "Yes" : "No"}</span>
            </div>
          </Col>

          <CKEditor
            initData={essentialTypesDetails?.description}
            config={{
              extraPlugins: 'table',
              removePlugins: 'elementspath',
              resize_enabled: false,
              toolbarGroups: [
                { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
                { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
                { name: 'insert' },
                { name: 'styles' },
                { name: 'colors' },
                { name: 'links' },
                { name: 'table' }
              ],
              // Optional: Configure table plugin defaults or allowed features
              table_removeTableTag: false
            }}
            onChange={(event) => {
              const data = event.editor.getData();
              setEssentialDetails((prev) => ({ ...prev, description: data }));
            }}
          />
          <Col lg={12} md={12} sm={12} xs={12}>
            <label className="mb-2">Feature Image : </label>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <label className="mb-2">All Images : </label>
            <Upload
              listType="picture-card"
              fileList={fileList}
              onPreview={handlePreview}
              onRemove={(file) => file?.id && handleDeleteImage(file.id)}
              onChange={handleChange}
              multiple
              beforeUpload={() => false}
            >
              {fileList.length >= 20 ? null : (
                <div>
                  <PlusOutlined />
                  <div style={{ marginTop: 8 }}>Upload</div>
                </div>
              )}
            </Upload>
          </Col>
          {previewImage && (
            <Image
              wrapperStyle={{ display: "none" }}
              preview={{
                visible: previewOpen,
                onVisibleChange: (visible) => setPreviewOpen(visible),
                afterOpenChange: (visible) => !visible && setPreviewImage(""),
              }}
              src={previewImage}
            />
          )}
        </Row>
      </Modal>

    </div>
  );
}

export default EssentialTypes;